<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import BrandMark from '@/components/ui/BrandMark.vue'

const open = ref(false)
const route = useRoute()

// finance / spiritual
const section = computed(() => route.meta?.section || 'finance')
const homePath = computed(() => (section.value === 'spiritual' ? '/spiritueel' : '/'))

// close on route change or click outside
function handleEsc(e){ if(e.key === 'Escape') open.value = false }
onMounted(() => window.addEventListener('keydown', handleEsc))
onBeforeUnmount(() => window.removeEventListener('keydown', handleEsc))
</script>

<template>
  <header class="site-header">
    <div class="header-bar">
      <div class="wrap header-inner">
        <!-- Brand -->
        <router-link :to="homePath" class="brand" aria-label="Ga naar home">
          <BrandMark size="md" />
        </router-link>

        <!-- Desktop nav -->
        <nav class="nav" aria-label="Hoofdmenu">
          <router-link :to="section==='spiritual' ? '/spiritueel' : '/'">Home</router-link>
          <router-link :to="section==='spiritual' ? '/spirituele-coaching' : '/financiele-coaching'">
            {{ section==='spiritual' ? 'Spirituele coaching' : 'Financiële coaching' }}
          </router-link>
          <router-link :to="section==='spiritual' ? '/wie-ben-ik-2' : '/wie-ben-ik'">Wie ben ik</router-link>
          <router-link :to="section==='spiritual' ? '/contact-2' : '/contact'">Contact</router-link>
        </nav>

        <!-- Mobile button (z-index > panel so it's always on top) -->
        <button class="burger" @click="open=!open" :aria-expanded="open ? 'true' : 'false'" aria-label="Open menu">
          <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <!-- Absolutely positioned dropdown (no layout shift) -->
      <div v-if="open" class="mobile-panel" @click.self="open=false">
        <div class="wrap">
          <div class="mobile-links">
            <router-link @click="open=false" :to="section==='spiritual' ? '/spiritueel' : '/'">Home</router-link>
            <router-link @click="open=false" :to="section==='spiritual' ? '/spirituele-coaching' : '/financiele-coaching'">
              {{ section==='spiritual' ? 'Spirituele coaching' : 'Financiële coaching' }}
            </router-link>
            <router-link @click="open=false" :to="section==='spiritual' ? '/wie-ben-ik-2' : '/wie-ben-ik'">Wie ben ik</router-link>
            <router-link @click="open=false" :to="section==='spiritual' ? '/contact-2' : '/contact'">Contact</router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
/* Visual tweaks specific to header live in base.css. */
</style>
